// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".addBox[data-v-29870767]{width:96%;text-align:center;font-size:20px;border:1px dashed #286ab4;border-radius:10px;background-color:rgba(55,134,153,.47058823529411764);margin:auto;height:40px;line-height:40px;cursor:pointer}", ""]);
// Exports
module.exports = exports;
